import { createContext, type ReactNode, useContext, useMemo } from 'react'

import { type InsightsRole } from './insightsRole'

export type InsightsAccount = {
  email: string | null
  displayName: string | null
  role: InsightsRole
}

const InsightsAccountContext = createContext<InsightsAccount | null>(null)

export const InsightsAccountProvider = ({
  email,
  displayName,
  role,
  children,
}: InsightsAccount & { children: ReactNode }) => {
  const account = useMemo(
    () => ({ email, displayName, role }),
    [email, displayName, role]
  )
  return (
    <InsightsAccountContext.Provider value={account}>
      {children}
    </InsightsAccountContext.Provider>
  )
}

/** Throws outside the guard: an absent account means a component escaped it. */
export const useInsightsAccount = (): InsightsAccount => {
  const account = useContext(InsightsAccountContext)
  if (!account) {
    throw new Error('useInsightsAccount used outside InsightsAuthGuard')
  }
  return account
}

export const useIsAdmin = (): boolean =>
  useInsightsAccount().role.kind === 'admin'
